import axios from "axios";
import { toast } from "react-toastify";

const API = axios.create({
  baseURL: process.env.REACT_APP_API_URL, 
  headers: {
    "ngrok-skip-browser-warning": "true", // Yeh line add karein
  },// ✅ Ngrok + /api/v1
  
});


// Request interceptor
API.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

// Response interceptor
API.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem("token");
      window.location.href = "/login";
    }
    if (error.response?.status === 403) {
      toast.error(error.response?.data?.message || "Access Denied: You do not have permission to perform this action.");
    }
    return Promise.reject(error);
  }
);

export default API;